import { render, staticRenderFns } from "./DuplicateReviewFilterBar.vue?vue&type=template&id=799a4500&scoped=true"
import script from "./DuplicateReviewFilterBar.vue?vue&type=script&lang=js"
export * from "./DuplicateReviewFilterBar.vue?vue&type=script&lang=js"
import style0 from "./DuplicateReviewFilterBar.vue?vue&type=style&index=0&id=799a4500&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799a4500",
  null
  
)

export default component.exports